import {
  addDays,
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
  addMonths,
} from 'date-fns'
import { DateRange } from 'react-day-picker'

interface ItemDatePeriods {
  period: DateRange
  label: string
  dateId: string
}

export const getDatePeriods = (): ItemDatePeriods[] => {
  const today = new Date()
  const dayOfWeek = today.getDay()
  const daysUntilSaturday = (6 - dayOfWeek + 7) % 7
  const daysUntilSunday = (7 - dayOfWeek) % 7

  return [
    {
      period: { from: today },
      label: 'hoje',
      dateId: 'hoje',
    },
    {
      period: { from: addDays(today, 1) },
      label: 'amanhã',
      dateId: 'amanha',
    },
    {
      period: { from: startOfWeek(today), to: endOfWeek(today) },
      label: 'nesta semana',
      dateId: 'esta-semana',
    },
    {
      period: {
        from: addDays(today, daysUntilSaturday === 0 ? 7 : daysUntilSaturday),
        to: addDays(today, daysUntilSunday === 0 ? 7 : daysUntilSunday),
      },
      label: 'neste fim de semana',
      dateId: 'este-fim-de-semana',
    },
    {
      period: {
        from: startOfWeek(addDays(today, 7)),
        to: endOfWeek(addDays(today, 7)),
      },
      label: 'na próxima semana',
      dateId: 'proxima-semana',
    },
    {
      period: {
        from: startOfMonth(today),
        to: endOfMonth(today),
      },
      label: 'neste mês',
      dateId: 'este-mes',
    },
    {
      period: {
        from: startOfMonth(addMonths(today, 1)),
        to: endOfMonth(addMonths(today, 1)),
      },
      label: 'no próximo mês',
      dateId: 'proximo-mes',
    },
  ]
}
